import request from '@/utils/request'

export function saveCoupletTemplate(data) {
  return request.post('/asset/couplet_template/save', data)
}

export function getCoupletTemplateList() {
  return request.get('/asset/couplet_template/list')
}

export function deleteCoupletTemplate(templateId) {
  return request.post('/asset/couplet_template/delete', { template_id: templateId })
}
